import type {InternalUnwrapVariables, PbeTransform} from './types';

import pbeTransform from './pbeTransform';
import GraphQlGatewayCompatibilityError from '../../shared/graphql/GraphQlGatewayCompatibilityError';

export default function internalPbeUnwrapWithError<
  TVars extends Record<string, any>,
  TPbe extends Partial<Record<keyof TVars, string>>,
  TMap extends Readonly<Record<string, ReadonlyArray<string>>>,
>(
  vars: TVars,
  pbe: TPbe,
  map: TMap,
): InternalUnwrapVariables<TVars, TPbe, TMap> {
  return pbeTransform(swap, vars, pbe, map) as InternalUnwrapVariables<
    TVars,
    TPbe,
    TMap
  >;
}

function swap(obj: unknown, transform: PbeTransform, key: string): unknown {
  if (obj && typeof obj === 'object') {
    if ('pbe_empty' in obj) {
      return '';
    }

    if ('pbe_value' in obj) {
      return transform(obj.pbe_value);
    }
  }

  if (obj != null) {
    throw new GraphQlGatewayCompatibilityError(
      `Malformed PBE field for property ${key} - passed type is ${typeof obj}`,
      key.split('.'),
    );
  }

  return transform(obj);
}
